import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profileImg from '../../images/profile_img.svg';
import location from '../../images/location.svg';
import save from '../../images/save.svg'
import heart from '../../images/heart.svg'
import dIcon from '../../images/d-icon.svg'
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { ToastContainer, toast } from "react-toastify";
import searchIcon from "../../images/search-icon.svg";

function RentProperties() {
    const [properties,setProperties] = useState([]);
    const [propertiesList, setPropertiesList] = useState([]);
    const [propertyArray, setPropertyArray] = useState([]);
    const [visibleLoadButton, setVisibleLoadButton] = useState(true);

    const fetchProperties = ()  => {
        axios.get(API_BASE_URL+`get/rent/properties?_skip=0&_limit=36`,{
        headers: {
            Authorization: `Bearer ${Bearer_Token}`,
        }
        })
        .then((response) => {
            setProperties(response.data.data.pData);
            setPropertyArray(response.data.data.pData);
            setPropertiesList(response.data.data.allData);
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }

    const handleSearchClick = (e) => {
        const searchTerm = e.target.value;
        if(searchTerm.length > 2){
            const filteredItems = propertiesList.filter((item) => {
                    return (
                        item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ||
                        item.amount.toLowerCase().indexOf(searchTerm) >= 0
                    )
                }
            );
            setProperties(filteredItems);
            setVisibleLoadButton(false);
        }else{
            setProperties(propertyArray);
            setVisibleLoadButton(true);
        }
    };

    useEffect(()=> {
        fetchProperties()
    },[]);

  return (
    <>
        <ToastContainer />
        <section class="grid_box">
            <div class="container">
                <div className="row align-items-center text_he_box">
                    <div className="col-md-4"><h4>Properties for Rent</h4></div>
                    <div className="col-md-4">  <div class="searchbox d-flex"><input class="form-control" placeholder="Search for Rent" type="text" onChange={handleSearchClick}/><button type="button"><img alt="search-icon" src={searchIcon} /></button></div></div>
                    <div className="col-md-4"> <h4 className="property-title text-end">Verified Properties</h4></div>
                </div>

                <div class="row g-5">
                    {properties.map((property) => (
                    <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12 property-des">
                        <div class="feature_image"> 

                        <Swiper
                        direction={'horizontal'}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        // onSlideChange={() => console.log('slide change')}
                        // onSwiper={(swiper) => console.log(swiper)}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Mousewheel,Pagination]}
                        className="mySwiper"
                        speed={1000}
                        mousewheel={true}
                        >
                        {property.photos.slice(0, 3).map((image) => (
                            <SwiperSlide>
                                <img className="property-image" src={ASSETS_URL+"properties/media/medium/"+image} alt="" width="100%" />  
                            </SwiperSlide>
                        ))}
                        </Swiper>
                        <span class="save"><img src={save} width="20px" alt="save"/></span>
                        <span class="profile_img"><img src={profileImg} width="30px" alt="profile_img"/></span>
                        <span class="heart"><img src={heart} width="25px" alt="heart"/></span>
                        </div>
                        <div class="text_feature">
                        <Link to={`/property/${property.id}`}><h4>{property.title}</h4></Link>
                        <span class="d-flex align-items-center">
                            {/* <img src={location} alt="location"/>  */}
                        <p>{property.location_title}</p></span>
                        <span class="d-flex justify-content-between align-items-center"><p>{property.square_feet} sq ft</p> <p>{property.number_of_bathroom} Bathrooms</p> <p>{property.number_of_bedroom} Bedrooms</p></span>
                        </div>
                        <div class="price_box d-flex align-items-center  justify-content-between ">
                        <h3>
                        { property.currency === 'AED' &&
                            <img src={dIcon} alt="" className="dirham-icon"/> 
                        }
                        {(() => {
                            switch (property.currency) {
                            case "AED":   return  new Intl.NumberFormat("en-AE", {currency: "AED", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                            case "USD": return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                            case "GBP":  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                            case "EUR": return new Intl.NumberFormat("en-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                            case "INR": return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                            default:      return "";
                            }
                        })()}
                        </h3>
                        <span>{property.listing_type.toUpperCase()}</span> </div>
                    </div>
                    ))}
                </div>
            </div>
        </section>

        {visibleLoadButton && (
        <div className="button_showmore text-center">
            <a href="#">Show More</a>
        </div>
        )}
    </>
  );
}

export default RentProperties;